export enum AuthGuards {
  GUEST,
  AUTH,
  SYSTEM,
}
